import { useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { useHudOverlay } from "widgets/hud/model/overlayStore";
import { AnimatedWrap, Head, Title, ToAll } from "./styles";
import { useOutClick } from "app/lib/hooks/useOutClick";
import { mergeRefs } from "shared/helpers";
import { Notifications } from "widgets/notifications";

export const NotificationsModal = () => {
    const openId = useHudOverlay((s) => s.openId);
    const close = useHudOverlay((s) => s.close);

    const containerRef = useRef<HTMLDivElement | null>(null);
    const nodeRef = useRef<HTMLDivElement | null>(null);

    useOutClick(containerRef, close);

    const isOpen = openId === "notifications";

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                // close();
            }
        };
        document.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev;
        };
    }, [isOpen, close]);

    return (
        <CSSTransition
            in={isOpen}
            timeout={{ enter: 200, exit: 150 }}
            classNames="hud-slide"
            unmountOnExit
            nodeRef={nodeRef}
        >
            <AnimatedWrap
                ref={mergeRefs(containerRef, nodeRef)}
                role="dialog"
                aria-modal="true"
            >
                <Head>
                  <Title>Уведомления</Title>
                  <ToAll to={'/notifications'} onClick={close}>Все уведомления</ToAll>
                </Head>
                <Notifications isModal />
            </AnimatedWrap>
        </CSSTransition>
    );
};

export default NotificationsModal;
